module.exports = __webpack_public_path__ + "static/sgc-b43f3401a09f75934deedb61df0b4f80.pdf";